import { useEffect, useState } from 'react';

import VisitReportsListExpandable from './VisitReportsListExpandable';

import AdvancedFilterDataTable from 'components/FilterDataTable/AdvancedFilterDataTable';
import useGetVisitReportsList from 'hooks/VisitReport/useGetVisitReportsList';
import { useGetVisitReportListTableColumns } from 'components/VisitReports/useGetVisitReportListTableColumns';
import useScreenSize from 'hooks/Screen/useScreenSize';
import { VisitReportsData } from 'api/visitReports/type';
import CreateVisitReportModal from 'pages/VisitsAndScheduleTasks/Modals/createVisitReportModal/CreateVisitReportModals';

interface VisitReportsPageProps {
  slug: string;
}

const VisitReportsList: React.FC<VisitReportsPageProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetVisitReportsList({ slug: slug || '', enabled: false });
  const columns = useGetVisitReportListTableColumns(slug || '');
  const searchFields = ['call_date', 'start_date', 'end_date'];
  const { isNotDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white">
      <AdvancedFilterDataTable<VisitReportsData>
        columns={columns}
        amountPerPageLabel="Reports Per Page"
        data={data || []}
        searchFields={searchFields}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotDesktop}
        expandableRowsComponent={row => <VisitReportsListExpandable data={row.data} slug={slug} />}
        isNotReportsTable={false}
      />
      <CreateVisitReportModal refetchVisitReports={refetch} objectSlug={slug} />
    </div>
  );
};

export default VisitReportsList;
